import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

let actingTenantId = null;
export function setActingTenant(id) { actingTenantId = id || null; }

let actingBusinessId = null;
export function setActingBusiness(id) { actingBusinessId = id || null; }

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("gb_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (actingTenantId) config.headers["X-Tenant-Id"] = actingTenantId;
  if (actingBusinessId) config.headers["X-Business-Id"] = actingBusinessId;
  return config;
});

export function apiErr(e, fallback = "Something went wrong") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").join(" ");
  return d?.msg || e?.message || fallback;
}

export function resolveUrl(url) {
  if (!url) return "";
  if (url.startsWith("http") || url.startsWith("data:") || url.startsWith("blob:")) return url;
  return `${process.env.REACT_APP_BACKEND_URL}${url}`;
}

export { API };
export default api;
